import { hasNonAlphanumeric, emailValidator } from '../mixins/stringMixins'
export default {
    required: value => !!value || 'Required.',
    alpha: v => hasNonAlphanumeric(v) || 'Must have one non alphanumeric character',
    email: v => emailValidator(v) || 'Must be a vaild email address',
    minChar(chars) {
        return v => v.length >= chars || `Min ${chars} characters`
    }
}